import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=97bcd39a&scoped=true&"
import script from "./FormEdit.vue?vue&type=script&lang=js&"
export * from "./FormEdit.vue?vue&type=script&lang=js&"
import style0 from "./FormEdit.vue?vue&type=style&index=0&id=97bcd39a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bcd39a",
  null
  
)

export default component.exports